// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"256":"component---src-pages-404-jsx","532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"256":"6774fbbdfb1e5cce139e","532":"4c515f8dff6a5833c95f","678":"33e480e803116b8920d7"}[chunkId] + ".js";
};